<template>
    <div class="vue-top__objects">
        <div class="vue-top__objects-container" ref="container">
            <div class="vue-top__objects-list"
                 ref="content"
                 v-touch:swipe.left="swipeLeft"
                 v-touch:swipe.right="swipeRight"
            >
                <a v-for="object in objects"
                     :key="object.id"
                     :href="object.link"
                   class="vue-top__objects-item"
                >
                    <div class="vue-top__objects-item-img">
                        <img :src="object.img" :alt="object.title">
                    </div>
                    <div class="vue-top__objects-item-title">{{ object.title }}</div>
                </a>
            </div>
        </div>

        <button v-if="!!overflow" @click="moveLeft" class="vue-top__button back" ref="back">
            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9L5 5L1 1" fill="#937545"/>
                <path d="M1 9L5 5L1 1" stroke="white" stroke-width="1.5"/>
            </svg>
        </button>

        <button v-if="!!overflow " @click="moveRight" class="vue-top__button forward" ref="forward">
            <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9L5 5L1 1" fill="#937545"/>
                <path d="M1 9L5 5L1 1" stroke="white" stroke-width="1.5"/>
            </svg>
        </button>
    </div>
</template>

<script>

export default {
    props: ['objects', 'level'],

    data() {
        return {
            container : null,
            content   : null,
            overflow  : false
        }
    },

    methods:{
        swipeLeft(){
            this.content.style.transform = 'none';
        },

        swipeRight(){
            const offset = this.content.clientWidth - this.container.clientWidth;
            this.content.style.transform = `translateX(-${offset}px)`;
        },

        moveLeft(){
            this.content.style.transform = 'none';
        },

        moveRight(){
            const offset = this.content.clientWidth - this.container.clientWidth;
            this.content.style.transform = `translateX(-${offset}px)`;
        },

        isOverflow() {
            if (this.$refs.container && this.$refs.content) {
                const containerWidth = this.$refs.container.clientWidth;
                const contentWidth = this.$refs.content.clientWidth;

                return Number(contentWidth) > Number(containerWidth);
            }
        }
    },

    mounted() {
        this.overflow = this.isOverflow();
        this.container = this.$refs.container;
        this.content = this.$refs.content;
    },
};
</script>

<style lang="scss">
    @import "./Objects";
</style>

